import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBillingStatus } from '../hooks/useBillingStatus';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children, adminOnly = false, allowArtisan = false, bypassPaywall = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();
  const { billing, loading: billingLoading } = useBillingStatus(!!user);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-amber-500 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/app" replace />;
  }

  // Artisan : accès limité à /app/bons-commande (et /app/parametres pour changer son mot de passe)
  if (user.role === 'artisan' && !allowArtisan) {
    if (!location.pathname.startsWith('/app/bons-commande') && !location.pathname.startsWith('/app/parametres')
        && !location.pathname.startsWith('/bons-commande') && !location.pathname.startsWith('/parametres')) {
      return <Navigate to="/app/bons-commande" replace />;
    }
  }

  // Paywall : trial expiré + non abonné → redirect vers /pricing
  // bypassPaywall = pour la page /pricing elle-même + /billing/* pour ne pas créer de boucle
  if (!bypassPaywall && !billingLoading && billing && !billing.can_access) {
    return <Navigate to="/pricing" state={{ from: location, reason: 'trial_expired' }} replace />;
  }

  return children;
};
